"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var blockFormat_1 = require("../utils/blockFormat");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * @internal
 */
function experimentToggleListType(editor, listType) {
    blockFormat_1.default(editor, function (region, start, end) {
        var vList = roosterjs_editor_dom_1.createVListFromRegion(region, true /*includeSiblingLists*/);
        if (vList) {
            vList.changeListType(start, end, listType);
            vList.writeBack();
        }
    });
}
exports.default = experimentToggleListType;
//# sourceMappingURL=experimentToggleListType.js.map